import {useEffect} from 'react';
import {FEATURE_TO_ROUTE_MAP, ROUTES} from '@contentlab/config/routesConstants';
import {ProjectStatus} from '@contentlab/types/project';
import {getDraftProjectId, removeDraftProjectId} from '@/utils/LtidStorage';
import useProjectQuery from '@/hooks/content-studio/use-project-query';
import useNavigation from '@/hooks/use-navigation';

function useNavigateToPendingDraftProject() {
  const navigation = useNavigation();
  const draftProjectId = getDraftProjectId();
  const {data: project} = useProjectQuery({
    id: draftProjectId,
    isDraft: true,
    onError: () => removeDraftProjectId(),
  });

  useEffect(() => {
    // if we have a draft project which is really in draft status => navigate to the correct feature page
    if (project) {
      if (project.status === ProjectStatus.DRAFT) {
        const redirectRoute = `${ROUTES.CONTENT_LAB}${
          FEATURE_TO_ROUTE_MAP[project.feature]
        }?projectId=${project.id}`;
        navigation.navigate(redirectRoute);
      } else {
        console.error(`Project is not in draft state`, {project});
      }
      removeDraftProjectId();
    }
  }, [project]);
}

export default useNavigateToPendingDraftProject;
